import { resolveApiBase } from "./apiBase";

const API = resolveApiBase();

export function defaultMisPath(mustChangePassword) {
  return mustChangePassword ? "/mis/change-password" : "/mis/stats";
}

export async function resolveMisPathFromToken(token) {
  if (!token) return "/login.html";
  try {
    const res = await fetch(`${API.replace(/\/$/, "")}/login`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.status === 401 || res.status === 403) return "/login.html";
    if (!res.ok) return "/mis/stats";
    const body = await res.json();
    const profile = body?.data?.[0];
    const must =
      Number(profile?.must_change_password) === 1 || profile?.must_change_password === true;
    return defaultMisPath(must);
  } catch (_e) {
    return "/mis/stats";
  }
}
